export const CATEGORIES_LOADING = 'CATEGORIES_LOADING';
export const CATEGORIES_SUCCESS = 'CATEGORIES_SUCCESS';
export const CATEGORIES_FAILURE = 'CATEGORIES_FAILURE';

export const FEEDBACKS_LOADING = 'FEEDBACKS_LOADING';
export const FEEDBACKS_SUCCESS = 'FEEDBACKS_SUCCESS';
export const FEEDBACKS_FAILURE = 'FEEDBACKS_FAILURE';
export const FEEDBACKS_EXPORT_LOADING = 'FEEDBACKS_EXPORT_LOADING';
export const FEEDBACKS_EXPORT_SUCCESS = 'FEEDBACKS_EXPORT_SUCCESS';
export const FEEDBACKS_EXPORT_FAILURE = 'FEEDBACKS_EXPORT_FAILURE';
export const FEEDBACKS_EXPORT_RESET = 'FEEDBACKS_EXPORT_RESET';
export const FEEDBACKS_ATTACHMENT_LOADING = 'FEEDBACKS_ATTACHMENT_LOADING';
export const FEEDBACKS_ATTACHMENT_SUCCESS = 'FEEDBACKS_ATTACHMENT_SUCCESS';
export const FEEDBACKS_ATTACHMENT_FAILURE = 'FEEDBACKS_ATTACHMENT_FAILURE';
export const FEEDBACKS_ATTACHMENT_RESET = 'FEEDBACKS_EXPORT_RESET';
export const CHANGE_CATEGORY_REQUEST = 'CHANGE_CATEGORY_REQUEST';
export const CHANGE_CATEGORY_SUCCESS = 'CHANGE_CATEGORY_SUCCESS';
export const CHANGE_CATEGORY_FAILURE = 'CHANGE_CATEGORY_FAILURE';

export const FEEDBACK_SEND_REQUEST = 'FEEDBACK_SEND_REQUEST';
export const FEEDBACK_SEND_SUCCESS = 'FEEDBACK_SEND_SUCCESS';
export const FEEDBACK_SEND_FAILURE = 'FEEDBACK_SEND_FAILURE';

export const REACTION_SAVE_REQUEST = 'REACTION_SAVE_REQUEST';
export const REACTION_SAVE_SUCCESS = 'REACTION_SAVE_SUCCESS';
export const REACTION_SAVE_FAILURE = 'REACTION_SAVE_FAILURE';

export const REACTION_DELETE_REQUEST = 'REACTION_DELETE_REQUEST';
export const REACTION_DELETE_SUCCESS = 'REACTION_DELETE_SUCCESS';
export const REACTION_DELETE_FAILURE = 'REACTION_DELETE_FAILURE';

export const FEEDBACK_DELETE_REQUEST = 'FEEDBACK_DELETE_REQUEST';
export const FEEDBACK_DELETE_SUCCESS = 'FEEDBACK_DELETE_SUCCESS';
export const FEEDBACK_DELETE_FAILURE = 'FEEDBACK_DELETE_FAILURE';

export const USERS_LOADING = 'USERS_LOADING';
export const USERS_SUCCESS = 'USERS_SUCCESS';
export const USERS_FAILURE = 'USERS_FAILURE';

export const BOOKMARKS_LOADING = 'BOOKMARKS_LOADING';
export const BOOKMARKS_SUCCESS = 'BOOKMARKS_SUCCESS';
export const BOOKMARKS_FAILURE = 'BOOKMARKS_FAILURE';
export const SAVE_BOOKMARK_REQUEST = 'SAVE_BOOKMARK_REQUEST';
export const SAVE_BOOKMARK_SUCCESS = 'SAVE_BOOKMARK_SUCCESS';
export const SAVE_BOOKMARK_FAILURE = 'SAVE_BOOKMARK_FAILURE';
export const DELETE_BOOKMARK_REQUEST = 'DELETE_BOOKMARK_REQUEST';
export const DELETE_BOOKMARK_SUCCESS = 'DELETE_BOOKMARK_SUCCESS';
export const DELETE_BOOKMARK_FAILURE = 'DELETE_BOOKMARK_FAILURE';
